import { BlockSkeleton } from 'components/secondaryMarket/shared/Blocks/BlockSkeleton';
import { FieldSkeleton } from 'components/secondaryMarket/shared/FieldSkeleton';
import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup';
import { FC } from 'react';

export const SecondaryTradeInformationSkeleton: FC = () => {
  return (
    <BlockSkeleton id="trade-information" labelSize={20}>
      <div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-12">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
      </div>
    </BlockSkeleton>
  );
};

SecondaryTradeInformationSkeleton.displayName = 'LiveTradeInformationSkeleton';
